module.exports = __webpack_public_path__ + "img/sieckFinesseSetup4.43da4b37.png";